import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { UserDetail, UserUpdate } from 'types/api'
import { BaseParams } from 'types/utils'

export function usePatchClient() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError
  // TODO: add success text for different roles maybe?
  const { t } = useTranslation('users')

  async function updateClient({ id, body }: BaseParams<UserUpdate, 'PATCH'>) {
    if (!id) throw new Error('ID client is required')
    const res = await apiClient.patch<UserDetail>(
      `${SNA_PREFIX}users/${id}`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateClient,
    onSuccess: (_, variables) => {
      toast.success({ message: t('toast.profileUpdated') })
      queryClient.invalidateQueries({ queryKey: ['client', variables.id] })
    },
    onError // Updated to use useOnError
  })
}
